import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHelpAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4079 8.57257C10.684 7.96919 11.2931 7.54999 12 7.54999C12.9665 7.54999 13.75 8.33349 13.75 9.29999C13.75 9.77435 13.5623 10.2033 13.2554 10.5192C13.1738 10.6033 13.0828 10.6941 12.9864 10.7903C12.6766 11.0996 12.3104 11.4651 12.0162 11.8431C11.619 12.3535 11.25 13.0067 11.25 13.8V14.9C11.25 15.1761 11.4738 15.4 11.7499 15.4H12.2501C12.5262 15.4 12.75 15.1761 12.75 14.9V13.8C12.75 13.4887 12.8929 13.159 13.1999 12.7644C13.4313 12.4671 13.6991 12.1996 13.9915 11.9074C14.1015 11.7975 14.215 11.6842 14.3313 11.5644C14.8992 10.9799 15.25 10.1801 15.25 9.29999C15.25 7.50506 13.7949 6.04999 12 6.04999C10.5187 6.04999 9.26879 7.04106 8.8773 8.39632C8.74706 8.84715 8.97457 9.29999 9.50001 9.29999C10.0686 9.29999 10.2355 8.94922 10.4079 8.57257Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9 16.9C12.9 17.3971 12.4971 17.8 12 17.8C11.503 17.8 11.1 17.3971 11.1 16.9C11.1 16.4029 11.503 16 12 16C12.4971 16 12.9 16.4029 12.9 16.9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconHelpAlt as ReactComponent };
